module.exports = __webpack_public_path__ + "img/woman-red.d43a9bb9.svg";